import { Grid } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import { serverUrl } from "../../services/apiService/baseUrl";
import FormikInput from "../../commonComponents/InputField/FormikInput";
function FirstStep({ setUseEffectRun, editData = null, setEditData, setStep }) {
  const handleSubmit = async (val) => {
    if (!localStorage.getItem("code")) {
      return tostMessage(400, "Code Not Found");
    }
    let url = editData
      ? apiEndPoint().UPDATE_PROJECT
      : apiEndPoint().CREATE_PROJECT2;
    const { status, data } = await postApi({
      url,
      params: {
        projectId: editData ? editData._id : null,
        projectName: val.projectName,
        projectDomain: "https://prathamlive.ai",
        projectLogo: editData
          ? serverUrl + editData.project_logo === val.projectLogo
            ? null
            : val.projectLogo
          : val.projectLogo,
        assertTeamLead: {
          label: "Harshit Bhatia",
          value: "64e68313ee064324b45adcef",
        },
        assertTeam: [
          {
            _id: "64ede1d411d339aec4fafc01",
            fullName: "Shivanshu Upadhyay",
          },
        ],
        code: localStorage.getItem("code"),
      },
    });
    tostMessage(status, data.message);
    if (status === 200) {
      console.log(status, data);
      setStep(1);
      //   setUseEffectRun((pre) => !pre);
      //   setEditData(null);
      //   window.location.reload();
    }
  };
  const initialVal = {
    projectName: editData ? editData?.project_name : "",
  };

  const validationSchema = Yup.object().shape({
    projectName: Yup.string()
      .required("Project name is required")
      .matches(
        /^[a-zA-Z][a-zA-Z0-9_. -]{0,29}$/,
        "Invalid Project name format"
      ),
    
  });

  return (
    <div>
      <Formik
        initialValues={initialVal}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
          <Form style={{ padding: "3rem" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <FormikInput
                  placeholder="Enter Project Name"
                  labelVal="Project Name"
                  name="projectName"
                  touched={touched.projectName}
                  errors={errors.projectName}
                />
              </Grid>
              
              {/* <Grid item xs={12} sm={4}>
                <div style={{ marginBottom: "0.4rem" }}>
                  <label style={{ fontWeight: "500" }}>Project Logo</label>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={
                      !values.projectLogo
                        ? "https://modernize-angular-main.netlify.app/assets/images/profile/user-1.jpg"
                        : values.projectLogo
                    }
                    alt="selectedImg"
                    height={50}
                    width={50}
                    style={{ marginInline: "6px", borderRadius: "5px" }}
                  />
                  <label
                    htmlFor="projectLogo"
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      color: "blue",
                      fontWeight: "600",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <CloudUploadIcon />
                    <span style={{ marginInline: "10px" }}>Upload Logo</span>
                  </label>
                  <input
                    id="projectLogo"
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImgUpload(e, setFieldValue)}
                    style={{ visibility: "hidden" }}
                  />
                </div>
              </Grid> */}

              <Grid item xs={12}>
                <div className="addRole">
                  <button type="submit" className="buttonAddRole">
                    {editData ? <>Update Project</> : <>Next</>}
                  </button>
                </div>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default FirstStep;
